import {
    login,
    getUser,
    corporation,
    physician,
    salesRep,
    imagingEngineer,
    resetPasswordPre,
    setPassword
} from '../../service/service'
import {resetPassword} from "@/service/service";

export default {
    name: 'login',
    data: function () {
        return {
            email: '',
            password: '',
            reMe: false,
            showMessage: '',
            showErrow: true,
            loginType: 'login',
            emailLogin: '',
            passwordLogin: '',
            confrimPasswordLogin: '',
            nameLogin: '',
            phoneNumberLogin: '',
            creatFromOk: false,
            emailForget: '',
            forgetFromOk: false,
            role: '',
            userId: '',
            token: '',
            pwd: '',
            checkPwd: '',
            code: '',
            pwdRe: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}/,
            status: false
        }
    },
    created() {
        if (localStorage.getItem("remember") != null){
            this.reMe = true;
            this.email = localStorage.getItem("email");
            console.log(this.email)
        } else {
            this.reMe = false;
            this.email = "";
            this.pwd = '';
        }
    },
    mounted() {
        // this.reMe =  localStorage.getItem("remember");
        if (localStorage.getItem("remember") != null){
            this.reMe = true;
            this.email = localStorage.getItem("email");
            console.log(this.email)
        } else {
            this.reMe = false;
            this.email = "";
            this.pwd = '';
        }
        console.log("当前是否选择"+this.reMe)
    },
    methods: {
        goToLogin() {
            window.location.href = 'https://cases.immersivetouch.com'
        },
        changePassword1() {
            if(this.pwd === ''){
                this.$Message.warning('The password cannot be empty.')
                return
            }
            if (this.pwd !== this.checkPwd) {
                this.$Message.warning("Passwords don't match.")
                return
            }
            if (this.pwd.length < 8) {
                this.$Message.warning('The password must be at least 8 characters.')
                return
            }

            resetPassword({
                id: this.userId,
                code: this.code,
                password: this.pwd,
                toUserId: this.userId
            }).then(res => {
                if (res.code === '0') {
                    this.status = true
                } else {
                    if (res.msg === '') {
                        this.$Message.warning('Unknown Error')
                    } else {
                        this.$Message.warning("Incorrect verification code")
                    }
                }
            })
        },
        forBackToLogin() {
            this.loginType = 'login'
            this.emailForget = ''
            this.forgetFromOk = false
        },
        sendEmail() {
            this.forgetFromOk = true
            resetPasswordPre({
                email: this.emailForget
            }).then(res => {
                if (res.code === '0') {
                    this.userId = res.data
                    this.forgetFromOk = true
                }
            })
        },
        frogotPassword() {
            this.email = ''
            this.password = ''
            this.reMe = false
            this.showMessage = ''
            this.showErrow = true
            this.loginType = 'froget'
            this.code = '';
            this.pwd = '';
            this.checkPwd = '';
        },
        reBackToLogin() {
            this.loginType = 'login'
            this.emailLogin = ''
            this.passwordLogin = ''
            this.confrimPasswordLogin = ''
            this.nameLogin = ''
            this.phoneNumberLogin = ''
            this.creatFromOk = false
        },
        register() {
            this.creatFromOk = true
        },
        createAccount() {
            this.email = ''
            this.password = ''
            this.reMe = false
            this.showMessage = ''
            this.showErrow = true
            this.loginType = 'create'
        },
        changeEmail() {
            this.showMessage = ''
            this.showErrow = true
        },
        changePassword() {
            if (this.passwordLogin === this.confrimPasswordLogin) {
                switch (this.role) {
                    case 'Corporation':
                        corporation.mine.setPassword({
                            id: this.token,
                            oldpwd: 'Itouch123456',
                            newpwd: this.passwordLogin
                        }).then(res => {
                            console.log(res)
                            if (res.code === '0') {
                                this.loginType = 'login'
                            } else if (res.code === '1') {
                                this.$Message.warning('Password length must be greater than 8 digits and contain upper and lower case letters and numbers')
                            }
                        })
                        break;
                    case 'Physician':
                        physician.mine.setPassword({
                            id: this.token,
                            oldpwd: 'Itouch123456',
                            newpwd: this.passwordLogin
                        }).then(res => {
                            console.log(res)
                            if (res.code === '0') {
                                this.loginType = 'login'
                            } else if (res.code === '1') {
                                this.$Message.warning('Password length must be greater than 8 digits and contain upper and lower case letters and numbers')
                            }
                        })
                        break;
                    case 'ImagingEngineer':
                        imagingEngineer.mine.setPassword({
                            id: this.token,
                            oldpwd: 'Itouch123456',
                            newpwd: this.passwordLogin
                        }).then(res => {
                            console.log(res)
                            if (res.code === '0') {
                                this.loginType = 'login'
                            } else if (res.code === '1') {
                                this.$Message.warning('Password length must be greater than 8 digits and contain upper and lower case letters and numbers')
                            }
                        })
                        break;
                    case 'SalesRep':
                        salesRep.mine.setPassword({
                            id: this.token,
                            oldpwd: 'Itouch123456',
                            newpwd: this.passwordLogin
                        }).then(res => {
                            console.log(res)
                            if (res.code === '0') {
                                this.loginType = 'login'
                            } else if (res.code === '1') {
                                this.$Message.warning('Password length must be greater than 8 digits and contain upper and lower case letters and numbers')
                            }
                        })
                        break;
                }
            } else {
                this.$Message.warning('The two passwords are not the same')
            }
            this.email = ''
            this.password = ''
        },
        login() {
            if (this.reMe) {
                localStorage.setItem("email", this.email);
                localStorage.setItem("remember", this.reMe);
            } else {
                localStorage.removeItem("email");
                localStorage.removeItem("remember");
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            login({
                Email: this.email,
                Password: this.password
            }).then(res => {
                console.log(res)
                this.$Spin.hide();
                if (res.Success) {
                    let NeedPwd = res.NeedPwd
                    sessionStorage.setItem("lastTime",new Date().getTime());
                    sessionStorage.setItem('token', res.UserUID)
                    this.token = res.UserUID
                    getUser({
                        UserUID: res.UserUID
                    }).then(res => {
                        console.log(res)
                        this.role = res.User.Role
                        if (res.User.Role === 'Corporation') {
                            if (NeedPwd === '1') {
                                this.loginType = 'changePwd'
                            } else {
                                this.$router.push({
                                    name: 'corporation-index'
                                })
                            }
                        } else if (res.User.Role === 'Physician') {
                            // if(NeedPwd !== '1'){
                            //     this.loginType = 'changePwd'
                            // }else{

                            // }
                            this.$router.push({
                                name: 'physician-index'
                            })
                        } else if (res.User.Role === 'ImagingEngineer') {
                            if (NeedPwd === '1') {
                                this.loginType = 'changePwd'
                            } else {
                                this.$router.push({
                                    name: 'imagingEngineer-index'
                                })
                            }
                        } else if (res.User.Role === 'SalesRep') {
                            if (NeedPwd === '1') {
                                this.loginType = 'changePwd'
                            } else {
                                this.$router.push({
                                    name: 'salesRep-index'
                                })
                            }
                        }
                    })
                } else {
                    this.showMessage = res.ErrorInfo
                }
            })
            // if(this.password !== '123456'){
            //   this.showErrow = false
            //   this.showMessage = this.$t('Usename or password was incorrect')
            // }else{
            //   if(this.reMe){
            //     localStorage.setItem('token','token')
            //   }else{
            //     sessionStorage.setItem('token','token')
            //   }
            //   if(this.email === 'test1@admin.com'){
            //     this.$router.push({
            //       name:'corporation-index'
            //     })
            //   }else if(this.email === 'test_mulitHos@doc.com'){
            //     this.$router.push({
            //       name:'physician-index'
            //     })
            //   }else if(this.email === 'test@eng.com'){
            //     console.log(1)
            //     this.$router.push({
            //       name:'imagingEngineer-index'
            //     })
            //   }else if(this.email === 'test1@sales.com'){
            //     this.$router.push({
            //       name:'salesRep-index'
            //     })
            //   }
            // }
        }
    }
}
